export const getHasRecaptchaFailed = message => {
  return message === 'recaptcha failed';
};
export const getIsMissingRecaptchaInformation = message => {
  return message === 'The recaptchaToken should be present on the request payload' || message === 'The recaptchaSiteKey should be present on the request payload' || message === 'The recaptcha token & site key should be present on the request payload';
};